// @flow
import React from "react";
import padlock from "../../images/icons/padlock.svg";
export function SafeOnlineShopping() {
    return (
        <div className="info-block-shopping">
            <img src={padlock} className="info-block-shopping__icon" />
            <div className="info-block-shopping__emphasis">Safe</div> online
            shopping
        </div>
    );
}
